@import 'styles/mixins';
@import 'styles/variables';

.container {
  max-width: 848px;
  width: 100%;
  padding-top: 30px;
  padding-bottom: 20px;

  .inviteButton {
    @include btn-sm-text;

    align-items: center;
    display: flex;
    height: 28px;

    svg {
      margin-right: 4px;

      path {
        fill: $green-20;
      }
    }
  }

  .inviteLink {
    align-items: center;
    background-color: $gray-5;
    border: 1px solid $gray-20;
    border-radius: 4px;
    display: flex;
    height: 40px;
    justify-content: space-between;
    padding: 6px 6px 6px 12px;
    width: 100%;

    .inviteLinkInput {
      background-color: inherit;
      border: none;
      color: $gray-50;
      font-size: 14px;
      height: auto;
      line-height: 16px;
      padding: 0;
      width: 100%;
    }

    &:focus-within {
      border-color: $green-50;
    }
  }
}
